export const Fonts = {
    roboto: 'Roboto Regular',
    robotoLight: 'Roboto Light',
    robotoMedium: 'Roboto Medium'
};
